<template>
  <v-container id="page-terms-use">
    <div class="page-title mb-5">{{$route.name}}</div>
    <c-card>
      <!-- 데이터 입력 -->
      <div v-if="editableFlag">
        <v-row align="center ">
          <v-col cols="12" sm="6" md="4">
            <v-select
              label="약관 유형을 선택해주세요."
              v-model="selectedTermsType"
              :items="termsTypeList"
              solo dense
              item-text="termsType"
              return-object
              class="pb-0"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="8">
            <v-radio-group v-model="selectedAppType" row readonly>
              <v-radio v-for="item in appTypeList" :label="item.configName" :value="item.configValue"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="mb-6">
            <v-text-field v-model="termsTitle" placeholder="제목을 입력해주세요." solo dense required
                          :rules="[v => !!v]"
                          hide-details :autofocus="true" color="navy" maxlength="1024"></v-text-field>
          </v-col>

          <v-col cols="12">
            <ckeditor v-model="editorData" :config="editorConfig" tag-name="textarea"></ckeditor>
          </v-col>
        </v-row>
      </div>
      <!-- 데이터 표시 -->
      <div v-else>
        <v-card-text>
          <div class="font-weight-black subtitle-1">{{ termsTitle }}</div>
          <div v-html="termsContents"></div>
        </v-card-text>
      </div>
    </c-card>
    <v-row justify="end">
      <div v-if="editableFlag">
        <c-btn class="mr-2 mt-3" color="blue" outlined @click="onSaveTerms">저장</c-btn>
        <c-btn class="mr-5 mt-3" color="blue" outlined @click="goTermsList">취소</c-btn>
      </div>
      <div v-else>
        <c-btn v-if="userInfo.role == 'SA'" class="mr-2 mt-3" color="blue" outlined @click="onEditable">수정</c-btn>
        <c-btn class="mr-5 mt-3" color="blue" outlined @click="goTermsList">돌아가기</c-btn>
      </div>
    </v-row>

  </v-container>
</template>

<script>

  export default {
    data() {
      return {
        typeId: '',
        titleId: '',

        termsTitle: '',
        selectedTermsType: '',

        termsTypeList: [],
        appTypeList:[],

        editableFlag: false,
        editorData: '',
        editorConfig: {
          language: 'ko',
          height: 500,
          autoGrow_onStartup: true,
          image: {
            // toolbar: [
            //   'imageTextAlternative',
            //   '|',
            //   'imageStyle:alignLeft',
            //   'imageStyle:full',
            //   'imageStyle:alignRight'
            // ],
            // styles: ['full', 'alignLeft', 'alignRight']
          },
          // The configuration of the editor.
        },


        termsContents: '',

      }
    },
    mounted() {
      const {typeId} = this.$route.params;
      if (typeId !== 'write') {
        //update
        this.reqGetTermsContents(typeId);
        this.reqGetTermsTitle(typeId);
      } else {
        this.editableFlag = true;
        this.reqGetTermsTypeList();
      }
      this.appTypeList = this.$store.state.config.app_type;
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch:{
      selectedTermsType(val) {
        this.selectedAppType = val.appType.configValue;
      }
    },
    methods: {
      async reqAddTerms(data) {
        try {
          const res = await this.$api.addTerms(data);

          this.termsContents = this.editorData;
          this.editableFlag = false;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqAddTerms'});
        }
      },
      onSaveTerms() {
        if (!this.termsTitle || !this.editorData || !this.selectedTermsType) {
          this.$store.commit('snackbar', {timeout: 2000, msg: '비어있는 필드가 있습니다.'});
          return;
        }
        let reqParam = {
          termsTitle : this.termsTitle,
          creatorId : this.$store.state.userInfo.loginId,
          termsContents : this.editorData,
          termsTypeId : this.selectedTermsType.id,
        };

        this.reqAddTerms(reqParam);
      },

      async reqGetTermsTitle(typeId) {
        try {
          const res = await this.$api.getTermsTitle(typeId);
          this.termsTitle = res.data.title;
          this.typeId = res.data.typeId;

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetTermsTitle'});
        }
      },

      async reqGetTermsContents(typeId) {
        try {
          const res = await this.$api.getTermsContents(typeId);
          this.termsContents = res.data.contents;

        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetTermsContents'});
        }
      },

      async reqGetTermsTypeList() {
        try {
          const res = await this.$api.getTermsTypeList();

          this.termsTypeList = res.data.filter((item) => item.flag === 'F');
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetTermsTypeList'});
        }
      },
      goTermsList() {
        this.$router.push('/termsBoard');
      },
      onEditable() {
        this.editableFlag = true;
        this.editorData = this.termsContents;
        this.termsTypeList.push(this.typeId);
        this.selectedTermsType = this.typeId;

      },

    },

  }
</script>

<style lang="scss" scoped>

  .ck-editor__editable_inline {
    min-height: 800px;
  }

  .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
    flex-wrap: wrap;
  }

</style>
